// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ykYv","title":"Header_title__3x-Mg","side":"Header_side__1-PqN"};